export default function (object) {
  return (object && object.constructor && object.constructor.name) || object;
}
